function getCartProducts() {
    $(".cart_loader_img").show();
    var t = "", e = 0, a = "";
    $(".prpwebs-popup-cart-load, .prpwebs-drawer-checkout").removeClass("emptycarttrue");
    $(".prpwebs-empty-cart").hide();
    jQuery.getJSON("/cart.js", function (r) {
        var s = "", i = "", p = "", n = "", l = "", d = "", c = "", o = "", u = r.items, m = 0;
        for (var v in u) {
            m++;
            var b = u[v];
            s = b.url;
            i = b.image;
            p = b.product_title;
            l = b.id;
            d = b.variant_id;
            c = b.quantity;
            o = (b.price / 100).toFixed(2);
            t += `<div class="prpwebs-item-cart-content" id="item-${m}">
                      <div class="prpwebs-item-content-variants">
                           <div class="prpwebs-item-cart-image">
                              <a href="${s}"><img class="prpwebs-cart-image" src="${i}" /></a>
                          </div> 
                    <div class="prpwebs-item-cart-description">
                      <div class="prpwebs-item-close">
                          <a href="javascript:void(0);" class="prpwebs-remove-item" data-id="${l}" onclick="removItemCart(${l},'item-${m}')">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                          </a>
                      </div>  
                    <div class="prpwebs-content-product-and-variant-title">  
                          <a href="${s}" class="prpwebs-product-title">${p}</a>  
                          <span class="prpwebs-variant-title">${n = null === b.variant_title ? " " : "Default Title" != b.variant_title ? b.variant_title : " "}</span>  
                          <div class="prpwebs-propertie-content"></div>  
                    </div> 
                    <div class="prpwebs-content-quantity-price">
                          <div class="prpwebs-item-cart-content-quantity">  
                              <div class="prpwebs-item-cart-qty prpwebs-item-${l} quantity center">
                                  <div class="js-qty__adjust_prpwebs1 prpwebs-cart-plus-minus" data-quantity="${c}" data-id="${l}" data-line="1">
                                      <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                                          <span class="prpwebs-minus-symbol" id="minus-${m}" onclick=minusItem(event,${m},${l})>-</span>
                                      </div>
                                      <input type="text" value="${c}" class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox" data-id="${l}" id="inputQuantity_${m}" disabled>
                                     <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                                          <span class="prpwebs-plus-symbol" id="plus-${m}" onclick=plusItem(event,${m},${l})>+</span>
                                    </div>
                                  </div>  
                              </div>
                          </div>
                          <div class="prpwebs-cart-content-price cartitem-id-${l}">  
                                <span class="prpwebs-compare-at-price"></span>
                                <span class="prpwebs-price-total prpwebs-desktop"><span class="money">$${o}</span></span>      
                          </div>
                    </div>
                    </div>
                    </div>
                    </div>`;
            e += b.quantity;
            a = `(${e} ${u.length > 1 ? "Items" : "Item"})`;
        }
    }).done(function () {
        $(".cart_loader_img").hide();
        $(".prpwebs_cartitems").html(t);
        $(".cart_items").html(a);
        $(".prpwebs-popup-drawer-load").addClass("active");
    });
}

function changeValues() {
    $.ajax({
        type: "get",
        url: "/cart.js",
        dataType: "json",
        success: function (t) {
            let e = (t.total_price / 100).toFixed(2);
            $(".cart__subtotal").html("$" + e);
            if (t.total_price < 4500) {
                let a = ((4500 - t.total_price) / 100).toFixed(2);
                $("#cartprogressbar").val(t.total_price / 100);
            } else $("#cartprogressbar").val(t.total_price / 100);
            t.total_price < t.original_total_price && $(".prpwebs-amount-sub-total .money-original").html(Shopify.formatMoney(t.original_total_price));
        }
    });
}

function filterupsellitems(t, e) {
    let a = [e];
    return Object.keys(t).filter(t => a.includes(t)).reduce((e, a) => (e[a] = t[a], e), {});
}

$("body").on("click", 'form[action="/cart/add"] .btn', function (t) {
    t.preventDefault();
    jQuery(".not_with_other, .kit_present_available").hide();
    let e = $(this).val();
    $(this).addClass("current_add");
    var a = $(this).closest("form").find("#quantity").val(), r = "";
    form_array = (form = $(this).closest("form")).serializeArray();
    r = jQuery("body").hasClass("template-product") ? 0 != $("#custom-variant-id").length ? form_array.find(t => "custom-variant-id" === t.name).value : form_array.find(t => "id" === t.name).value : form_array.find(t => "id" === t.name).value;
    void 0 == a && (a = 1);
    let s = form_array.find(t => "handle" === t.name), i = 0;
    jQuery.getJSON("/cart.js", function (t) {
        let p = t.items;
        p.map(t => { 6722346647613 == t.product_id && (i = 1); });
        1 == i ? (void 0 == s ? jQuery(".kit_present_available").html(`<p>This product can't be added to your cart if Flor\xe9 Clinical Microbiome is already added.</p>`) : jQuery(".kit_present_available").html(`<p>${s.value} can't be added to your cart if Flor\xe9 Clinical Microbiome is already added.</p>`), jQuery(".kit_present_available").show(), a = 0) : 39766354198589 == r && p.length > 0 && (jQuery(".not_with_other").show(), a = 0);
        !function t() {
            var s = Object.keys(form_array).some(function (t) { return "properties[shipping_interval_unit_type]" === form_array[t].name; }), i = Object.keys(form_array).some(function (t) { return "selling_plan" === form_array[t].name; });
            if (s) {
                let p = form_array.find(t => "properties[shipping_interval_frequency]" === t.name), n = form_array.find(t => "properties[shipping_interval_unit_type]" === t.name);
                var l = { quantity: a, id: r, properties: { shipping_interval_frequency: p.value, shipping_interval_unit_type: n.value } };
            } else if (i) var l = { quantity: a, id: r, selling_plan: form_array.find(t => "selling_plan" === t.name).value };
            else var l = { quantity: a, id: r };
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: l,
                success: function (t) {
                    getCartProducts();
                    changeValues();
                    $(".prpwebs-popup-drawer-load").addClass("active");
                    $("body").addClass("prpwebs-cart-open");
                    $(".prp-cartdrawer-form .current_add").val("Added!");
                },
                error: function (t) {
                    getCartProducts();
                    changeValues();
                    $(".prp-cartdrawer-form .current_add").val("sold out!");
                    setTimeout(function () {
                        $(".prp-cartdrawer-form .current_add").val(e);
                        $(".prp-cartdrawer-form .btn").removeClass("current_add");
                    }, 100);
                }
            });
            product_id_added = r;
        }();
    });
});

$("body").on("click", ".drawer_slider .add-to-cart-button", function (t) {
    t.preventDefault();
    let e = $(this).html();
    $(this).addClass("current_add");
    $(this).html("ADDING...");
    var a = $(this), r = $(this).attr("data-vid");
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { quantity: 1, id: r },
        success: function (t) {
            getCartProducts();
            changeValues();
            a.html("Added!");
            a.parent().parent().parent().remove();
        },
        error: function (t) {
            getCartProducts();
            changeValues();
            $(".prp-cartdrawer-form .current_add").val("sold out!");
            setTimeout(function () {
                a.html(e);
                a.removeClass("current_add");
            }, 100);
        }
    });
});

jQuery.getJSON("/cart.js", function (t) {
    0 == t.items.length ? ($(".prpwebs-popup-cart-load, .prpwebs-drawer-checkout").addClass("emptycarttrue"), $(".prpwebs-empty-cart").show()) : ($(".prpwebs-popup-cart-load, .prpwebs-drawer-checkout").removeClass("emptycarttrue"), $(".prpwebs-empty-cart").hide());
});
